import AddInstaller from "./AddInstaller";

export default AddInstaller;
